<template>
  <div>
    <headPage></headPage>
    <div class="banner_box">
      <img class="img_banner" src="../../assets/img/banner.jpg" alt="" />
      <div class="content">
        <div class="big_msg"><span>银保镖</span> - 国内领先的电子保函平台</div>
        <div class="mini_msg">在线办理、电话办理全支持</div>
      </div>
    </div>
    <div class="about">
      <div class="title">关于我们</div>
      <div>
        <p style="text-indent: 2em">
          人银金融是由人民银行机关事务管理局批准，由北京人银科工贸有限责任公司投资，于2017年9
          月15日成立的一家专业从事金融相关信息及服务的国有控股公司。人银金融以服务实体经济为己任，以合作共赢为基础，以创新和服务为手段，通过匹配全国各类金融机构，助力贸易市场、核心客户上下游企业发展，高效推动资金资产对接的金融服务平台。随着国家
          “减费降负”各项政策推行，为减少企业资金占用，切实降低企业成本费用，保函替代保证金、保函网络化、电子化的趋势愈加明显，银保镖电子保函平台应运而生，与银行、保险、担保公司合作开展电子保函业务，进一步通过用电子数据代替物理纸张的保函全流程办理方式，解决传统保函业务流动资金占用、办理周期长、办理门槛高、纸质保函难保存等缺陷。
        </p>
        <p style="text-indent: 2em">
          多年来，银保镖电子保函系统成功接入多家央企国企系统、地方公共资源交易中心，通过海量的数据积累、过硬的技术实力、完善的运营团队，实现了投标、履约、预付款、质量保证等保函的全流程在线办理。高效推动全国范围内的保函数字化转型。
        </p>
      </div>
    </div>
    <footPage></footPage>
  </div>
</template>

<script>
import headPage from '@/components/head/index.vue'
import footPage from '@/components/foot/index.vue'
export default {
  components: { headPage, footPage },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
